// Génération et impression des avis de passage (une page par contribuable)
import axios from "axios";
import mairieLogo from "../../assets/img/nrf.png";
import { API_BASE_URL } from "../../constants/api_constants";

const AVIS_IMPRESSION_ENDPOINT = `${API_BASE_URL}/taxpayers/avis-passage/imprimer`;
const IMPRESSION_CONCURRENCY = 5;

// Identifiant découpé en groupes de 3 chiffres depuis la droite : 123456789 -> "123-456-789"
const formatContribuableId = (id) => String(id ?? "").replace(/\B(?=(\d{3})+(?!\d))/g, "-");

// contribuables : [{ nom, contribuableId, quartierNom, communeNom }]
export function printAvisPassage(contribuables) {
  const annee = new Date().getFullYear();
  const dots = (n) => "…".repeat(n);

  let htmlPages = "";

  contribuables.forEach((c) => {
    const quartierNom = c.quartierNom || "";
    const communeNom = c.communeNom || "Lemba";
    const villeNom = "Kinshasa";
    const denomination = c.nom || "";
    const contribuableId = formatContribuableId(c.contribuableId);

    htmlPages += `
      <div class="page-avis">
        <div class="entete">
          <div class="logos">
            <img class="logo" src="${mairieLogo}" alt="Logo" />
          </div>
          <div class="infos">
            <div class="ville">VILLE DE KINSHASA</div>
            <div class="commune">Commune de <strong>${communeNom}</strong></div>
            <div class="service">Service de L’Economie</div>
          </div>
        </div>
        <div class="ligne-separation"></div>

        <div class="titre">
          AVIS DE PASSAGE ET DE RECOUVREMENT DE LA TAXE<br />
          <span>PROFESSIONNELLE ANNUELLE</span>
        </div>

        ${contribuableId ? `<div class="contribuable-id">N° Contribuable : <strong>${contribuableId}</strong></div>` : ""}

        <p class="justifie destinataire">
          Madame, Mademoiselle, Monsieur, Responsable des ETS(STE) <strong>${denomination}</strong><br />
          Sis(e) au N° ${dots(21)}, de l’avenue ${dots(30)}<br />
          quartier <strong>${quartierNom ? quartierNom : dots(28)}</strong>, Commune de <strong>${communeNom}</strong>;
        </p>

        <p class="justifie">
          En exécution de l’ordre de mission sur les opérations d’identification des opérateurs économiques, d’enrôlement éléments d’assiette de la Taxe Professionnelle Annuelle et de son recouvrement pour l’exercice en cours, il vous est demandé de nous apprêter les éléments suivants, dans les 48 heures qui suivront la réception du présent avis&nbsp;:
        </p>

        <div class="liste">
          <div class="liste-item">1. Les copies des Autorisations d’ouverture de chaque activité exercée&nbsp;;</div>
          <div class="liste-item">2. Les preuves de paiement de la Taxe Professionnelle Annuelle <strong>${annee}</strong>.</div>
        </div>

        <div class="nb">
          <strong>N.B :</strong> Tout refus de collaboration, toute fausse déclaration, toute dissimulation d’activités ou toute obstruction au recensement, expose le contrevenant aux sanctions prévues par les textes législatifs et réglementaires en vigueur.
        </div>

        <div class="signature">
          <div class="signature-date">
            Fait à <strong>${villeNom}</strong>, le &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/ <strong>${annee}</strong>
          </div>
          <div class="signature-titre">
            LE CHEF D’EQUIPE
          </div>
        </div>
      </div>
    `;
  });

  const htmlContent = `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<title>Avis de Passage - Lots de contribuables</title>
<style>
@page { size: 215.9mm 279.4mm; margin: 18mm 18mm 18mm 18mm; }
* { box-sizing: border-box; }
html, body {
  margin: 0; padding: 0; background: white; color: #000;
  -webkit-print-color-adjust: exact; print-color-adjust: exact;
}
body {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12pt; line-height: 1.55; padding: 0;
}
p { margin: 0 0 15px 0; }
.page-avis {
  page-break-after: always;
  display: flex; flex-direction: column; min-height: 100vh;
}
.page-avis:last-child { page-break-after: auto; }
.entete { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 30px; position: relative; }
.entete .logos { display: flex; align-items: center; }
.entete .logo { width: 120px; height: auto; }
.entete .infos { text-align: right; font-family: Arial, Helvetica, sans-serif; line-height: 1.4; padding-top: 10px; }
.entete .infos .ville { font-weight: bold; font-size: 12pt; color: #1a3c5e; }
.entete .infos .commune { font-weight: bold; font-size: 12pt; color: #FF0000; margin-bottom: 5px; }
.entete .infos .service { color: #00B0F0; font-size: 12pt; }
.entete .ligne-separation { border-top: 1.5px solid #000; margin-bottom: 30px; }
.titre { text-align: center; font-size: 14pt; font-weight: bold; text-transform: uppercase; line-height: 1.5; margin-bottom: 35px; font-family: Arial, Helvetica, sans-serif; }
.titre span { text-decoration: underline; }
.justifie { text-align: justify; font-family: Arial, Helvetica, sans-serif; }
.contribuable-id { text-align: center; white-space: nowrap; font-size: 12pt; letter-spacing: 0.5px; margin: -20px 0 25px 0; font-family: Arial, Helvetica, sans-serif; }
.destinataire { text-indent: 15mm; margin-bottom: 25px; }
.liste { margin-bottom: 25px; padding-left: 15mm; font-family: Arial, Helvetica, sans-serif; }
.liste-item { margin-bottom: 10px; text-align: justify; }
.nb { text-align: justify; margin-bottom: 40px; padding: 15px; background-color: #fffcf5; border: 1px solid #e0d0a0; border-radius: 4px; font-family: Arial, Helvetica, sans-serif; }
.signature { text-align: center; margin-top: 40px; font-family: Arial, Helvetica, sans-serif; }
.signature-date { margin-bottom: 30px; }
.signature-titre { font-weight: bold; margin-bottom: 30px; }
</style>
</head>
<body>
${htmlPages}
</body>
</html>`;

  const iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = 'none';
  document.body.appendChild(iframe);

  const iframeDoc = iframe.contentWindow.document;
  iframeDoc.open();
  iframeDoc.write(htmlContent);
  iframeDoc.close();

  iframe.contentWindow.onload = () => {
    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        if (document.body.contains(iframe)) document.body.removeChild(iframe);
      }, 1000);
    }, 500);
  };
}

// Enregistre côté API l'impression de l'avis pour chaque contribuable (par matricule contribuable_id).
// Retourne { success, failed, skipped } : skipped = contribuables sans contribuable_id.
export async function enregistrerImpressionsAvis(contribuableIds) {
  const token = sessionStorage.getItem("authToken");
  const headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const valid = contribuableIds.filter(id => id !== null && id !== undefined && String(id).trim() !== '');
  const ids = [...new Set(valid.map(id => String(id).trim()))];
  const result = { success: 0, failed: [], skipped: contribuableIds.length - valid.length };

  for (let i = 0; i < ids.length; i += IMPRESSION_CONCURRENCY) {
    const batch = ids.slice(i, i + IMPRESSION_CONCURRENCY);
    const settled = await Promise.allSettled(
      batch.map(id => axios.post(AVIS_IMPRESSION_ENDPOINT, { contribuable_id: id }, { headers }))
    );
    settled.forEach((r, j) => {
      if (r.status === 'fulfilled' && r.value.data?.success !== false) result.success++;
      else {
        console.error(`❌ Enregistrement impression avis ${batch[j]}:`, r.reason || r.value?.data);
        result.failed.push(batch[j]);
      }
    });
  }
  return result;
}

// Message de synthèse à afficher après l'enregistrement des impressions
export function describeImpressionsResult({ success, failed, skipped }) {
  const parts = [`${success} impression(s) d'avis enregistrée(s)`];
  if (failed.length) parts.push(`${failed.length} échec(s) d'enregistrement`);
  if (skipped) parts.push(`${skipped} contribuable(s) sans matricule ignoré(s)`);
  return parts.join(", ") + ".";
}
